import { Component, Inject, OnInit } from '@angular/core';
import * as XLSX from 'xlsx';
import { IssueSellerCreditNoteRegisterInDetailComponent } from '../issue-seller-credit-note-register-in-detail/issue-seller-credit-note-register-in-detail.component';
import { DigisubservicesService } from '../services/digisubservices.service';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-issue-seller-credit-note-in-detail-officer',
  templateUrl: './issue-seller-credit-note-in-detail-officer.component.html',
  styleUrls: ['./issue-seller-credit-note-in-detail-officer.component.scss']
})
export class IssueSellerCreditNoteInDetailOfficerComponent implements OnInit {

  currentDate: Date = new Date();
  startDate: any;
  endDate: any;
  CreditadvtOffInDFormBenas: any[] = [];
  CreditadvtOffInDTotalTds: number = 0;
  CreditadvtOffInDTotalOther: number = 0;
  CreditadvtOffInDTotal: number = 0;
  repName: string = '';
  offRepName: string = '';
  issueDates1: any;
  show: boolean = false;
  issueName: any;
  issueDates: any;
  reportType: any;

  constructor(
    private dialogRef: MatDialogRef<IssueSellerCreditNoteRegisterInDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private toaster: ToastrService
  ) {}

  ngOnInit(): void {
   this.startDate = this.data.startDate;
    this.endDate = this.data.endDate;
    this.repName = this.data.rep_name;
    this.issueName = this.data.issue_name;
    this.issueDates = this.data.issue_date;
    this.offRepName = this.data.off_rep_name;
    this.reportType = this.data.reportType;
    this.currentDate = new Date();
    this.getIssueCreditRegiOffInDetails();
  }

  getIssueCreditRegiOffInDetails() {
    const req: any = {
      rep_name: this.repName,
      start_date: this.startDate,
      end_date: this.endDate,
      off_rep_name: this.offRepName,
      issue_name: this.issueName,
      issue_date: this.issueDates
    };

    this.service.getIssueCreditRegiOffInDetails(req).subscribe({
      next: (data: any) => {
        this.CreditadvtOffInDFormBenas = data || [];

        // Reset totals
        this.CreditadvtOffInDTotalTds = 0;
        this.CreditadvtOffInDTotalOther = 0;
        this.CreditadvtOffInDTotal = 0;

        // Calculate totals
        for (const repData of this.CreditadvtOffInDFormBenas) {
          this.CreditadvtOffInDTotalTds += parseFloat(repData.tds_amt) || 0;
          this.CreditadvtOffInDTotalOther += parseFloat(repData.other_credit_amt) || 0;
          this.CreditadvtOffInDTotal += parseFloat(repData.total) || 0;
        }
      },
      error: (err) => {
        console.error('Error fetching credit note details', err);
        this.toaster.error('Failed to fetch credit note details');
      }
    });
  }

  exportExcel(fileName: string): void {
    const element = document.getElementById('print-section1');
    if (!element) {
      this.toaster.error("Export element not found");
      return;
    }

    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }

  printPage3(): void {
    this.show = true;
    const printSection = document.getElementById('print-section');
    if (!printSection) {
      console.error("Print section not found!");
      return;
    }

    const printContent = printSection.innerHTML;
    const screenWidth = window.screen.availWidth;
    const windowWidth = 1400;
    const leftPosition = screenWidth - windowWidth - 50;
    const printWindow = window.open('', '', `width=${windowWidth},height=1000,top=50,left=${leftPosition},scrollbars=yes`);

    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(`
        <html>
        <head>
          <title>Print Report</title>
          <style>
            @media print {
              @page { size: A3 landscape; margin: 3mm; }
              body { font-family: Arial; font-size: 10px; margin: 0; padding: 0; }
              table { width: 100%; border-collapse: collapse; }
              th, td {
                padding: 3px 5px;
                border: 1px solid black;
                font-size: 10px;
              }
              th { background-color: #f2f2f2; }
              .noPrint { display: none !important; }
              .footer-line {
                position: fixed;
                bottom: 0;
                width: 100%;
                height: 2px;
                background-color: black;
              }
              thead { display: table-header-group; }
              tfoot { display: table-footer-group; }
              td.balance-value, td.amount {
                text-align: right;
              }
            }
          </style>
        </head>
        <body>
          <div class="print-section">
            ${printContent}
            <div class="footer-line"></div>
          </div>
          <script>
            window.onload = function () {
              const table = document.querySelector('table');
              if (!table) return;

              let headerRowIndex = -1;
              for (let i = 0; i < Math.min(10, table.rows.length); i++) {
                const row = table.rows[i];
                const texts = Array.from(row.cells).map(cell => cell.textContent.trim());
                if (texts.includes('Invoice No') || texts.includes('Receipt No') || texts.includes('Balance')) {
                  headerRowIndex = i;
                  break;
                }
              }

              if (headerRowIndex >= 0) {
                let thead = table.querySelector('thead');
                if (!thead) {
                  thead = document.createElement('thead');
                  table.insertBefore(thead, table.firstChild);
                }
                thead.appendChild(table.rows[headerRowIndex]);
              }

              setTimeout(() => {
                window.print();
                setTimeout(() => window.close(), 500);
              }, 200);
            };
          </script>
        </body>
        </html>
      `);
      printWindow.document.close();
    } else {
      console.error("Failed to open print window.");
    }
  }
}
